import { render, staticRenderFns } from "./FriendsInCompany.vue?vue&type=template&id=81ad18a0&scoped=true&"
import script from "./FriendsInCompany.vue?vue&type=script&lang=js&"
export * from "./FriendsInCompany.vue?vue&type=script&lang=js&"
import style0 from "./FriendsInCompany.vue?vue&type=style&index=0&id=81ad18a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ad18a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81ad18a0')) {
      api.createRecord('81ad18a0', component.options)
    } else {
      api.reload('81ad18a0', component.options)
    }
    module.hot.accept("./FriendsInCompany.vue?vue&type=template&id=81ad18a0&scoped=true&", function () {
      api.rerender('81ad18a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/FriendsInCompany.vue"
export default component.exports